export const SYSTEM_PAGES: Page[] = [
  {
    title: 'Home',
    route: '',
    path: '/',
    icon: 'mdiHome',
    color: 'primary',
    index: true,
    sidebar: true,
  },
  {
    title: 'Login',
    route: 'login',
    path: '/login',
    icon: 'mdiLogin',
    index: true,
    sidebar: false,
  },
  {
    title: 'Certificado',
    route: 'certificado',
    path: '/certificado',
    icon: 'mdiLogin',
    index: true,
    sidebar: false,
  },
  {
    title: 'Cursos',
    route: 'curso',
    path: '/',
    icon: 'mdiBookOpen',
    index: true,
    sidebar: false,
    dynamic: true,
  },
  {
    title: 'Usuários',
    route: 'usuario',
    path: '/usuario',
    icon: 'mdiAccount',
    color: 'primary',
    index: true,
    sidebar: true,
    require: {
      permissions: ['administrador', 'gestor', 'desenvolvedor']
    }
  },
  {
    title: 'Administrador',
    route: 'admin',
    path: '',
    icon: 'mdiDatabaseCogOutline',
    color: 'primary',
    index: false,
    sidebar: true,
    dynamic: true,
    require: {
      permissions: ['administrador', 'gerente', 'desenvolvedor']
    },
    tabs: [
      {
        title: 'Cursos',
        route: 'curso',
        path: '/admin/curso'
      },
      {
        title: 'Categorias',
        route: 'categoria',
        path: '/admin/categoria'
      },
      {
        title: 'Tipos de Usuário',
        route: 'tipo-usuario',
        path: '/admin/tipo-usuario',
        require: {
          permissions: ['desenvolvedor']
        },
      }
    ]
  }
]